import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WE_RIDER_LOGO_URL as weRiderLogo } from "../../services/local/institutionalBranding";
import { completeWeRiderMercadoPagoConnection } from "../../services/supabase/weRiderPaymentsService";
import useWePedidosBranding from "./useWePedidosBranding";
import "../../styles/WeRider.css";

export default function WeRiderMercadoPagoCallback() {
  useWePedidosBranding("Rider", true, weRiderLogo);
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const params = new URL(window.location.href).searchParams;
    const providerError = params.get("error_description") || params.get("error");
    if (providerError) {
      setError(providerError);
      return undefined;
    }
    completeWeRiderMercadoPagoConnection({
      code: params.get("code") || "",
      state: params.get("state") || "",
    })
      .then(() => {
        if (mounted) {
          navigate("/we-pedidos/rider?mercado_pago=connected", { replace: true });
        }
      })
      .catch((requestError) => {
        if (mounted) {
          setError(
            requestError?.message || "No pudimos conectar Mercado Pago al Rider."
          );
        }
      });
    return () => {
      mounted = false;
    };
  }, [navigate]);

  return (
    <main className="we-rider-callback-shell">
      <section className="we-rider-callback-panel">
        <img src={weRiderLogo} alt="We! Rider" />
        {error ? (
          <>
            <h1>No pudimos conectar Mercado Pago</h1>
            <p>{error}</p>
            <a className="we-rider-primary" href="/we-pedidos/rider">
              Volver al panel Rider
            </a>
          </>
        ) : (
          <>
            <h1>Conectando Mercado Pago</h1>
            <p>Estamos validando la cuenta que recibira los cobros con QR.</p>
          </>
        )}
      </section>
    </main>
  );
}
